import { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/expensereport/Data Table Component/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/hubs/update_data_modal";
import HubDetailModal from "../../components/hubs/Hub Details";

export default function ExpenseReport() {
  const title = "Outlay Report";

  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [chartData, setChartData] = useState({});
  const [totalDirectExpense, setTotalDirectExpense] = useState(0);
  const [totalIndirectExpense, setTotalIndirectExpense] = useState(0);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showHubDetailModal, setShowHubDetailModal] = useState(false);
  const [selectedHub, setSelectedHub] = useState(null);

  const fetchCategories = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expense-categories`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (Array.isArray(res.data.expenseCategories)) {
        setCategories(res.data.expenseCategories);
      } else {
        console.error("Invalid category response format");
      }
    } catch (err) {
      console.error("Failed to fetch categories", err);
    }
  };

  const generateColumns = () => {
    const defaultColumns = [
      {
        name: <b>Hub Name</b>,
        selector: (row) => row.hubName,
        sortable: true,
        wrap: true, // ✅ allows multi-line text
      },
      {
        name: <b>Debited Amount</b>,
        selector: (row) => row.debitAmount,
        sortable: true,
      },
      {
        name: <b>Direct Expense</b>,
        selector: (row) => {
          let total = 0;
          Object.values(row.expensesByCategory || {}).forEach((cat) => {
            const type = cat.expense?.[0]?.id_expenseCategory?.type;
            if (type === "Direct") {
              total += cat.summary?.debitAmount || 0;
            }
          });
          return total;
        },
        sortable: true,
      },
      {
        name: <b>Indirect Expense</b>,
        selector: (row) => {
          let total = 0;
          Object.values(row.expensesByCategory || {}).forEach((cat) => {
            const type = cat.expense?.[0]?.id_expenseCategory?.type;
            if (type === "Indirect") {
              total += cat.summary?.debitAmount || 0;
            }
          });
          return total;
        },
        sortable: true,
      },
    ];

    const categoryColumns = categories.map((category) => ({
      name: <b>{category.name}</b>,
      selector: (row) => {
        const categoryKey = Object.keys(row.expensesByCategory || {}).find(
          (key) => key.toLowerCase() === category.name.toLowerCase()
        );

        const summary = row.expensesByCategory?.[categoryKey]?.summary;

        if (!summary) return "-";

        const amount =
          summary.debitAmount ||
          summary.creditAmount ||
          summary.salaryAmount ||
          0;

        return amount ? `${amount}` : "-";
      },
      sortable: true,
    }));

    return [...defaultColumns, ...categoryColumns];
  };

  const fetchData = async (filterFromDate = "", filterToDate = "") => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    let url = `${process.env.REACT_APP_BASE_URL}/api/v1/expenses/hubByDate`;
    const params = {};

    if (filterFromDate && filterToDate) {
      params.fromDate = filterFromDate;
      params.toDate = filterToDate;
    } else {
      const today = new Date();
      params.fromDate = moment(today)
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      params.toDate = moment(today)
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");
    }

    try {
      const response = await axios.get(url, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data?.data || [];
      console.log("Fetched Expenses:", response.data.data);

      setApiState(data);
      const calculateExpenseSums = (data) => {
        let direct = 0;
        let indirect = 0;

        data.forEach((hub) => {
          Object.values(hub.expensesByCategory || {}).forEach((cat) => {
            const type = cat.expense?.[0]?.id_expenseCategory?.type;
            const amount = cat.summary?.debitAmount || 0;
            if (type === "Direct") direct += amount;
            else if (type === "Indirect") indirect += amount;
          });
        });

        setTotalDirectExpense(direct);
        setTotalIndirectExpense(indirect);
      };

      setApiCol(generateColumns());
      calculateExpenseSums(data);
    } catch (err) {
      console.error("Error fetching expense data:", err);
    }
  };

  const handleFilterApply = (from, to) => {
    setIsFiltered(true);
    setFromDate(from);
    setToDate(to);
    fetchData(from, to);
  };

  const handleRemoveFilters = () => {
    setFromDate("");
    setToDate("");
    fetchData();
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      fetchData();
    }
  }, [categories]);

  const prepareChartData = (data) => {
    const hubs = data.map((hub) => hub.hubName || "-");
    const debitedAmounts = data.map((hub) => hub.debitAmount || 0);

    const colors = [
      "rgba(255, 99, 132, 0.6)",
      "rgba(54, 162, 235, 0.6)",
      "rgba(255, 206, 86, 0.6)",
      "rgba(75, 192, 192, 0.6)",
      "rgba(153, 102, 255, 0.6)",
      "rgba(255, 159, 64, 0.6)",
    ];

    const dynamicColors = hubs.map((_, i) => colors[i % colors.length]);

    setChartData({
      labels: hubs,
      datasets: [
        {
          label: "Debited Amount",
          data: debitedAmounts,
          backgroundColor: dynamicColors,
          borderColor: dynamicColors.map((c) => c.replace("0.6", "1")),
          borderWidth: 1,
        },
      ],
    });
  };

  useEffect(() => {
    prepareChartData(apistate);
  }, [apistate]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
      />
      <HubDetailModal
        show={showHubDetailModal}
        onHide={() => setShowHubDetailModal(false)}
        hub={selectedHub}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
              </div>
              <div className="card-body">
                <div className="mb-4" style={{ height: "300px" }}>
                  {chartData.labels ? (
                    <Bar
                      data={chartData}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: true },
                          title: { display: true, text: "Total Trips per Hub" },
                        },
                      }}
                      height={250}
                    />
                  ) : (
                    <p>Loading chart...</p>
                  )}
                </div>

                {/* <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3"> */}
                <div className="col-md-9 mb-2 d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center px-3 py-2 rounded"
                    style={{
                      background:
                        "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                      color: "#fff",
                      fontWeight: "600",
                      minWidth: "220px",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} className="me-2" />
                    Direct Expense: ₹{totalDirectExpense.toLocaleString()}
                  </div>

                  <div
                    className="d-flex align-items-center px-3 py-2 rounded"
                    style={{
                      background:
                        "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
                      color: "#000",
                      fontWeight: "600",
                      minWidth: "220px",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  >
                    <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    Indirect Expense: ₹{totalIndirectExpense.toLocaleString()}
                  </div>
                </div>
                <br />

                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="hubName"
                    title_btn={true}
                    title="Vehicle List"
                    apidata={apistate}
                    columns={apicol}
                    onFilterApply={handleFilterApply}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
